module.exports = __webpack_public_path__ + "static/media/Question.dea1c70b.scss";


//////////////////
// WEBPACK FOOTER
// ./src/shared/FormAnswer/Form/Question/Question.scss
// module id = 1417
// module chunks = 0